import _ from 'lodash';
// Do not use js destruction for 'process.env' as it doesn't work correctly with 'dotenv-webpack' module
const { IS_CLOUDSEARCH_ENABLED } = process.env;
const S3_CONTAINER = process.env.S3_CONTAINER_URL;

const isCloudSearchEnabled =
  _.isString(IS_CLOUDSEARCH_ENABLED) && IS_CLOUDSEARCH_ENABLED === 'true';

const S3_FOLDER_RECORDINGS = 'recordings';
const S3_FOLDER_INTRO_MESSAGES = 'intro-messages';

module.exports = {
  S3_CONTAINER,
  S3_DOWNLOAD_PATH: `/api/Containers/${S3_CONTAINER}/download/`,
  IS_CLOUDSEARCH_ENABLED: isCloudSearchEnabled,
  S3_FOLDER_RECORDINGS,
  S3_FOLDER_INTRO_MESSAGES,
};



// WEBPACK FOOTER //
// ./config/config.js